import { camelCase, startCase } from 'lodash';

import { CitizenshipStatus as GqlCitizenshipStatus } from '@willow/graphql-iso/src/app/backend';
import { CitizenshipStatus } from '@willow/types-iso';

export function getCitizenshipStatusLabel(status: GqlCitizenshipStatus | undefined): string | undefined;
export function getCitizenshipStatusLabel(status: CitizenshipStatus | undefined): string | undefined;
export function getCitizenshipStatusLabel(
  status: GqlCitizenshipStatus | CitizenshipStatus | undefined,
): string | undefined {
  if (!status) {
    return undefined;
  }

  switch (status) {
    case GqlCitizenshipStatus.UsCitizen:
    case 'usCitizen':
      return 'US Citizen';
    case GqlCitizenshipStatus.UsNational:
    case 'usNational':
      return 'US National';
    case GqlCitizenshipStatus.LawfulPermanentResident:
    case 'lawfulPermanentResident':
    case GqlCitizenshipStatus.ConditionalPermanentResident:
    case 'conditionalPermanentResident':
    case GqlCitizenshipStatus.Refugee:
    case 'refugee':
    case GqlCitizenshipStatus.Asylee:
    case 'asylee':
    case GqlCitizenshipStatus.Unknown:
    case 'unknown':
      return startCase(camelCase(status));
    default:
      return undefined;
  }
}
